// flag.service.ts
import { Injectable } from '@angular/core';
import { BehaviorSubject } from 'rxjs';

@Injectable({
  providedIn: 'root'
})
export class FlagService {
  private nameSource = new BehaviorSubject<string>('');
  currentName = this.nameSource.asObservable();
  actionEvent: any;

  constructor() { }

  updateName(name: string) {
    this.nameSource.next(name);
  }
}
